import { EventEmitter, Input, Output } from '@angular/core';

export abstract class VfzeImportStepComponent {

  @Input() data: any;
  @Output() backCallback = new EventEmitter();
  @Output() submitCallback = new EventEmitter();
}
